import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { HashRouter} from "react-router-dom";
import App from './App';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'mobx-react'
import { HeaderWithRouter } from './components/Header';
import 'bootstrap/dist/css/bootstrap.css';
import {  appStore } from './mobx/AppStore';
import Modal from 'react-modal';

Modal.setAppElement('#root')

ReactDOM.render(
    <Provider store={appStore}>
       <HashRouter>
          <div id="react_content" style={{display: "grid", gridTemplateRows: "min-content 1fr", minHeight: "calc(100vh - 190px)"}} >
                <HeaderWithRouter />
                <App />
          </div>
       </HashRouter> 
    </Provider>,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx